import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import store from '@/store'

// 创建 axios 实例
const request = axios.create({
  baseURL: '/api',
  timeout: 10000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = store.state.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // blob 响应直接返回
    if (response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res.data
  },
  error => {
    const message = error.response?.data?.message || '网络错误'
    if (error.response?.status === 401) {
      store.dispatch('logout')
      router.push('/login')
      Message.error('登录已过期，请重新登录')
    } else {
      Message.error(message)
    }
    return Promise.reject(error)
  }
)

export default request
